import { render, staticRenderFns } from "./BaseGrid.vue?vue&type=template&id=550eda66"
import script from "./BaseGrid.vue?vue&type=script&lang=js"
export * from "./BaseGrid.vue?vue&type=script&lang=js"
import style0 from "./BaseGrid.vue?vue&type=style&index=0&id=550eda66&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports